import React from 'react';
import Advantage from './Advantage';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

const List = (props) => {

  const renderAdvantages = () => {
    return props.items.map((item, index) => {

      const handleHover = () => {
        props.onMouseEnter(item, index);
      }

      return (
        <Grid item xs={12} md={6} key={index}>
          <Advantage className={props.index === index ? "active" : ""} key={index} item={item} onMouseEnter={handleHover} icon={props.icon}/>
        </Grid>
      );
    });
  }

  return (
    <Container>
      <Grid container justifyContent='center'>
      {renderAdvantages()}
      </Grid>
    </Container>
  )
}

export default List;